import React from 'react'
import classNames from 'classnames'

interface FormFieldProps {
  fullWidth?: boolean
  mds?: boolean
  hidden?: boolean
  classes?: string
  children: any
}

const FormField = ({
  fullWidth = false,
  mds = false,
  hidden,
  children
}: FormFieldProps) => {
  const formFieldClass = classNames('field-wrapper', {
    'relative flex flex-nowrap flex-shrink basis-3/5 grow w-auto mr-0 xl:mr-3 xl:mb-4':
      !fullWidth,
    'relative flex flex-wrap flex-shrink basis-3/5 grow w-auto mr-0 mb-4':
      fullWidth,
    // 'mb-3': !mds,
    'mb-4': mds,
    hidden: hidden
  })

  return <div className={formFieldClass}>{children}</div>
}

export default FormField
